<template>
	<div class="shop-product-check">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h1>Heartbeat</h1>

		<div class="content-wrapper">
			<div class="button-container" @click="getShops()">
				<div class="big-button">
					Refresh
				</div>
			</div>
		</div>

		<div class="heartbeat-table heartbeat-warpper header">
			<div>Shop Name</div>
			<div>Heartbeat</div>
			<div>Last Download</div>
			<div>Last Upload</div>
			<div>Sub Server Version</div>
		</div>

		<div v-if="shops.length > 0">
			<div v-for="(shop, index) of shops" :key="index" class="heartbeat-table">
				<div class="header">{{ shop.name }}</div>
				<div v-if="shop.sync && shop.sync.last_lookup">
					<span :class="statusClass(shop.sync.last_lookup)"></span>
					{{ convertTime(shop.sync.last_lookup) }}
				</div>

				<div v-if="shop.sync && shop.sync.last_complete">
					{{ convertTime(shop.sync.last_complete) }}
				</div>

				<div v-if="shop.sync && shop.sync.last_upload">
					{{ convertTime(shop.sync.last_upload) }}
				</div>

				<div v-if="shop.version">
					{{ shop.version }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	title: 'Heartbeat',
	name: 'heartbeat',
	data: () => ({
		limit: 20,
		isLoading: false,
		shops: []
	}),

	mounted: async function() {
		if (this.$store.state.auth) {
			this.$axios.defaults.headers.common['Authorization'] = 'Token ' + this.$store.state.auth
		}

		await this.getShops()

		// await this.heartbeat()
	},

	computed: {},

	methods: {
		// Verify if the brand ID and values are valid
		heartbeat: async function() {
			return
			// if (this.shops.length > 0) {
			// 	this.shops.map(shop => {
			// 		let lookup = shop.sync.last_lookup ? shop.sync.last_lookup : 0
			// 		let complete = shop.sync.last_complete ? shop.sync.last_lookup : 0
			//     let upload = shop.sync.last_upload ? shop.sync.last_lookup : 0
			// 	})
			// }
		},

		convertTime: function(time) {
			return this.$moment(time).fromNow()
		},

		statusClass: function(time) {
			if (time) {
				let a = this.$moment(time) // from API
				let b = this.$moment() // Date now

				let minsAgo = b.diff(a, 'minutes')

				var color = ''

				if (minsAgo < 10) {
					color = 'green'
				} else if (minsAgo < 60) {
					color = 'yellow'
				} else {
					color = 'red'
				}

				return color
			}
		},

		// Get list of shops
		getShops: async function() {
			this.shops = []
			const apiGetShops = await this.$api.getShops({})

			apiGetShops.data.list.map(shop => {
				// Find and remove HO shops
				let find_ho = shop.name.indexOf('HO_')

				if (find_ho == -1) {
					this.shops.push(shop)
				}
			})

			// this.shops = apiGetShops.data.list
		}
	}
}
</script>

<style scoped>
@import '../styles/GeneralStyles.css';
</style>
